<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-05-18 13:38:37
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-06-15 10:29:59
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\newPatientmanage\components\UserEvent\components\addDialog.vue
-->
<template>
<!-- 新增编辑 查看 新增评估弹窗 -->
    <div class="add-dialog">
        <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        v-if="dialogVisible"
        width="40%"
        :close-on-click-modal='false'
        >   
            <div class="header">
                <p></p>
                <h1>基本信息</h1>
            </div>
            <div class="content">
                <el-scrollbar style="height: 100%;font-size: 12px;width:100%">
                    <el-form ref="form" :rules="rules" :model="form" label-width="170px" size="small">
                        <el-form-item v-if='edit == false' label="事件记录号：">
                            <span>{{ form.id }}</span>
                        </el-form-item>
                        <el-form-item label="上报事件业务类型：" prop='eventType'>
                            <el-select v-if="edit"  v-model="form.eventType" style="width:100%" placeholder="请选择上报事件业务类型">
                                <el-option label="图文咨询" value="图文咨询"></el-option>
                                <el-option label="电话咨询" value="电话咨询"></el-option>
                                <el-option label="视频咨询" value="视频咨询"></el-option>
                                <el-option label="在线复诊" value="在线复诊"></el-option>
                                <el-option label="在线处方" value="在线处方"></el-option>
                                <el-option label="在线签约" value="在线签约"></el-option>
                                <el-option label="检查预约" value="检查预约"></el-option>
                                <el-option label="远程门诊" value="远程门诊"></el-option>
                                <el-option label="远程会诊" value="远程会诊"></el-option>
                                <el-option label="住院预约" value="住院预约"></el-option>
                                <el-option label="远程影像" value="远程影像"></el-option>
                                <el-option label="远程心电" value="远程心电"></el-option>
                                <el-option label="远程病理" value="远程病理"></el-option>
                                <el-option label="远程转诊" value="远程转诊"></el-option>
                                <el-option label="其他" value="其他"></el-option>
                            </el-select>
                            <span v-else>{{ form.eventType }}</span>
                        </el-form-item>
                        <el-form-item label="患者姓名：" prop='patientName'>
                            <span>{{ form.patientName }}</span>
                        </el-form-item>
                        <el-form-item label="患者电话：" prop='phone'>
                            <span>{{ form.phone }}</span>
                        </el-form-item>
                        <el-form-item label="身份证号：" prop='idCard'>
                            <span>{{ form.idCard }}</span>
                        </el-form-item>
                        <el-form-item label="上报科室：" prop='department'>
                            <span>{{ form.departmentName }}</span>
                        </el-form-item>
                        <el-form-item label="上报人：" prop='reportName'>
                            <el-input v-if="edit" v-model="form.reportName" placeholder="请输入上报人姓名"></el-input>
                            <span v-else>{{ form.reportName }}</span>
                        </el-form-item>
                        <el-form-item label="事件发生时间：" prop='eventCreateTime'>
                            <el-date-picker v-if="edit" style="width:100%" type="datetime" value-format='yyyy-MM-dd HH:mm:ss' placeholder="请选择事件发生时间" v-model="form.eventCreateTime"></el-date-picker>
                            <span v-else>{{ form.eventCreateTime }}</span>
                        </el-form-item> 
                        <el-form-item label="事件上报时间：" prop='eventReportTime'>
                            <el-date-picker v-if="edit" style="width:100%" type="datetime" value-format='yyyy-MM-dd HH:mm:ss' placeholder="请选择事件上报时间" v-model="form.eventReportTime"></el-date-picker>
                            <span v-else>{{ form.eventReportTime }}</span>
                        </el-form-item>
                        <el-form-item label="事件发生描述：" prop='eventDescribe'>
                            <el-input v-if="edit" type="textarea" placeholder="请输入您要描述的内容" v-model="form.eventDescribe"></el-input>
                            <span v-else>{{ form.eventDescribe }}</span>
                        </el-form-item>
                        <el-form-item label="发生的主要原因：" prop='eventCause'>
                            <el-input v-if="edit" type="textarea" placeholder="请输入发生的主要原因" v-model="form.eventCause"></el-input>
                            <span v-else>{{ form.eventCause }}</span>
                        </el-form-item>
                        <el-form-item label="采取的措施：" prop='measure'>
                            <el-input v-if="edit" type="textarea" placeholder="请输入采取的措施" v-model="form.measure"></el-input>
                            <span v-else>{{ form.measure }}</span>
                        </el-form-item>
                        <el-form-item label="患者的损害程度描述：" prop='damageExtent'>
                            <el-input v-if="edit" type="textarea" placeholder="请输入患者的损害程度描述" v-model="form.damageExtent"></el-input>
                            <span v-else>{{ form.damageExtent }}</span>
                        </el-form-item>
                        <el-form-item label="后续改进措施：" prop='improveMeasure'>
                            <el-input v-if="edit" type="textarea" placeholder="请输入后续改进措施" v-model="form.improveMeasure"></el-input>
                            <span v-else>{{ form.improveMeasure }}</span>
                        </el-form-item>
                        <el-form-item label="处理结果：" prop='result'>
                            <el-input v-if="edit" type="textarea" placeholder="请输入处理结果" v-model="form.result"></el-input>
                            <span v-else>{{ form.result }}</span>
                        </el-form-item>
                        <el-form-item style="margin-top:50px;margin-bottom:50px">
                            <el-button type="primary" @click="gotoEdit" style="width:110px;height:32px;background:#1A7BFC;border-color:#1A7BFC" v-if='viewBtn'>去编辑</el-button>
                            <el-button style="width:110px;height:32px;" @click="resetForm" v-if="viewBtn == false">重置</el-button>
                            <el-button type="primary" @click="addAdverse" style="width:110px;height:32px;background:#1A7BFC;border-color:#1A7BFC" v-if='btn_crtol == true && viewBtn == false'>保存</el-button>
                            <el-button type="primary" @click="editAdverse" style="width:110px;height:32px;background:#1A7BFC;border-color:#1A7BFC" v-if='editBtn && viewBtn == false'>保存</el-button>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { apiAddAdverseEvent ,apiPlatform_department,apiuploadEvent} from '../../../api/treatmentPlan'
    export default {
        data() {
            return {
                title:'患者不良事件上报填写',//标题
                dialogVisible: false,//弹窗
                form:{},
                editBtn:false,
                departmentArr:[],
                edit:true,
                btn_crtol:true,
                rules: {
                    eventType: [
                        { required: true, message: '请选择上报事件业务类型', trigger: 'blur' }
                    ],
                    reportName: [
                        { required: true, message: '请输入上报人姓名', trigger: 'blur' }
                    ],
                    eventCreateTime: [
                        { required: true, message: '请选择事件发生时间', trigger: 'blur' }
                    ],
                    eventReportTime: [
                        { required: true, message: '请选择事件上报时间', trigger: 'blur' }
                    ],
                    eventDescribe: [
                        { required: true, message: '请输入您要描述的内容', trigger: 'blur' }
                    ],
                    eventCause: [
                        { required: true, message: '请输入发生的主要原因', trigger: 'blur' }
                    ],
                    measure: [
                        { required: true, message: '请输入采取的措施', trigger: 'blur' }
                    ],
                    damageExtent: [
                        { required: true, message: '请输入患者的损害程度描述', trigger: 'blur' }
                    ],
                    improveMeasure: [
                        { required: true, message: '请输入后续改进措施', trigger: 'blur' }
                    ],
                },
                viewBtn:false,
            }
        },
        created () {
        },
        methods: {
            /**
             * @description:  新增打开弹窗
             * @param {*}
             * @return {*}
            */
            openDialog(val){
                this.form = {}
                this.editBtn = false
                this.title = '患者不良事件上报填写'
                this.btn_crtol = true
                this.form.patientId = val.patientId
                this.form.patientName = val.patientName
                this.form.idCard = val.idCard
                this.form.departmentName = val.departmentName
                this.form.departmentId = val.departmentId
                this.form.phone = val.mobile
                this.dialogVisible = true
                this.edit = true
                this.departmentList()
            },
            resetForm() {
                this.form = {
                    ...this.form,
                    eventType: '',
                    reportName: '',
                    eventCreateTime: '',
                    eventReportTime: '',
                    eventDescribe: '',
                    eventCause: '',
                    measure: '',
                    damageExtent: '',
                    improveMeasure: '',
                    result: ''
                }
            },
            /**
             * @description:  新增不良事件
             * @param {*}
             * @return {*}
            */
            addAdverse(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        apiAddAdverseEvent({...this.form}).then(res=>{
                            if(res.code == 0){
                                this.$message({
                                    message: '成功',
                                    type: 'success'
                                });
                                this.dialogVisible = false
                                this.$parent.archivesList()
                            }else{
                                this.$message.error(res.message);
                            }
                        })     
                    } else {
                        return false;
                    }
                });
            },
            /**
             * @description:  编辑打开弹窗
             * @param {*}
             * @return {*}
            */
            editDialog(val){
                this.editBtn = true
                this.form = {...val}
                this.form.department = val.departmentName
                this.title = '患者不良事件记录编辑'
                this.edit = true
                this.btn_crtol = false
                this.viewBtn = false
                this.dialogVisible = true
                this.departmentList()
            },
            //查看打开弹窗
            viewDialog(val){
                this.viewBtn = true
                this.editBtn = false
                this.form = {...val}
                this.form.department = val.departmentName
                this.title = '患者不良事件记录查看'
                this.edit = false
                this.btn_crtol = false
                this.dialogVisible = true
                this.departmentList()
            },
            gotoEdit(){
                this.viewBtn = false
                this.edit = true
                this.editBtn = true
            },
            //编辑保存按钮
            editAdverse(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        apiuploadEvent({...this.form}).then(res=>{
                            if(res.code == 0){
                                this.$message({
                                    message: '成功',
                                    type: 'success'
                                });
                                this.dialogVisible = false
                                this.$parent.archivesList()
                            }else{
                                this.$message.error(res.message);
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            /**
             * @description:  获取上报科室接口
             * @param {*}
             * @return {*}
            */
            departmentList(){
                apiPlatform_department({}).then(res=>{
                    this.departmentArr = res.data
                })
            },
            //选择上报科室 的change 事件
            departmentChange(val){
                this.form.departmentName = val.name
                this.form.departmentId = val.id
            },
            
        },
    }
</script>

<style lang="less" scoped>
.header{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    p{
        width: 4px;
        height: 15px;
        background: #1A7BFC;
        margin-right: 12px;
    }
    h1{
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
    }
}
.add-dialog{
    .title{
        font-size: 14px;
        color: #000;
        border-left: 4px solid #1A7BFC;
        padding-left: 10px;
        font-weight: bold;
        margin-bottom: 30px;
    }
    .content{
        height: calc(80vh - 160px);
        width: 100%;
    }
}
/deep/.el-dialog{
    height: 80vh;
}
/deep/.el-dialog__title{
    font-weight: 26px;
    color: #333;
    font-weight: bold;
}

</style>
